<svg class="logo logo--login" viewBox="0 0 111 39.96">
  <use xlink:href="#ab-logo"></use>
</svg>

<form #verifyMfaForm="ngForm" id="verifyMfaForm" class="form form--auth" (ngSubmit)="verifyMfa()" method="post">
  <app-error-notification [errors]="errorMessages"></app-error-notification>

  <div class="mb-0150 auth-card mat-card--simple mat-card--border">
    <div class="auth-card__header">
      <h1 class="auth-card__title">
        Additional Verification Required
      </h1>

      <ng-container *ngIf="isSmsMfaMethod; else totpLoginHint">
        <p class="auth-card__subtitle">
          Enter the 6-digit code sent to your phone number<ng-container *ngIf="maskedPhone"> ending in <strong>{{ maskedPhone }}</strong></ng-container>.
        </p>
      </ng-container>
      <ng-template #totpLoginHint>
        <p class="auth-card__subtitle">
          Enter the 6-digit code from your authenticator app.
        </p>
      </ng-template>
    </div>

    <div class="auth-card__content">
      <mat-form-field [hideRequiredMarker]="true" class="col__ ongray mb-0">
        <mat-label>Verification Code</mat-label>
        <input
          matInput
          id="mfaCode"
          name="mfaCode"
          placeholder="000000"
          required
          type="text"
          maxlength="6"
          [(ngModel)]="mfaCode"
          appAutofocus
          autocomplete="one-time-code"
          inputmode="numeric"
          pattern="[0-9]*">
      </mat-form-field>

      <p *ngIf="isSmsMfaMethod" class="txt-meta-01 vert-0050">
        Didn't receive a code? <button type="button" class="link link--small pl-0" (click)="resendCode()">Send again</button>
      </p>
    </div>
  </div>

  <div class="mb-0100">
    <button type="submit" id="verifyButton" class="btn btn--full btn--lg btn--submit" [disabled]="isSubmitting || verifyMfaForm.invalid">
      <span *ngIf="!isSubmitting">Verify</span>
      <span *ngIf="isSubmitting">Verifying...</span>
    </button>
  </div>

  <div class="center">
    <button type="button" class="auth-back-btn" (click)="useDifferentAccount()">
      Use a different account
    </button>
  </div>
</form>
